 <template>

 <v-dialog v-model="createSpotdialog" persistent max-width="500px">
      <v-btn fab  slot="activator" color="red" dark> <v-icon>add</v-icon></v-btn>
 <v-card color="grey lighten-4" flat offset-md4 >
      <v-container grid-list-md pa-3>
            <v-flex xs1 style="float:right">
              <v-btn flat fab small @click="createSpotdialog=false"> <v-icon>close</v-icon></v-btn>
          </v-flex>
        <v-layout row wrap>
          <v-flex xs12>
            <div style="color: purple; text-align:center;"><h4>Add new Spot</h4></div>
          </v-flex>
          <v-flex xs12>
          <v-flex xs6>
        Point :{{(max +1)}}
            </v-flex>
               <v-layout row wrap>
            </v-layout>
          </v-flex>
          <v-layout row wrap>
          <v-flex xs12>
            <v-text-field 
            name="title" 
            label="Title"
            id="title"
            v-model="title"
            maxlength="80"
            required></v-text-field>
          </v-flex>
          <v-layout row >             
        <v-flex xs2 offset-xs4>
            <v-text-field 
            name="x" 
            label="x"
            id="x"
            v-model="coord.x"
            number
            ></v-text-field>
          </v-flex>
           <v-flex xs2>
            <v-text-field 
            name="y" 
            label="y"
            id="y"
            v-model="coord.y"
            number
            ></v-text-field>
          </v-flex>
           <v-flex xs2>
            <v-text-field 
            name="z" 
            label="z"
            id="z"
            v-model="coord.z"
            number
            ></v-text-field>
          </v-flex>

        </v-layout>

          </v-layout>

        <v-flex xs12>
          </v-flex>

      <div style="margin-left:44%;">
            <v-spacer></v-spacer>
          <v-btn @click="onSubmitChanges" color="red" style="color:white;" 
          :disabled="!formIsValid"
          > Create Spot </v-btn>
</div>
        </v-layout>
      </v-container>
    </v-card>
    </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      coord: {
      x:"",
      y:"",
      z:""
      },
      id: "",
      createSpotdialog: false,
      title: "",
  
    };
  },
  computed: {
    formIsValid() {
      return this.title !== "" && this.max !== undefined ;
    },
    max(){
        return  this.$store.getters.maxSpotId;
    }
  },
  methods: {
    onSubmitChanges() {
      if (!this.formIsValid) {
        console.log(this.$store.getters.user.email);
        return;
      }
      var loption;
      if(this.lang==='English'){
          loption= 1;
      }
      else {
          loption=2;
      }
      this.createSpotdialog = false;
      const spotData = {
        title: this.title,
        id:this.max +1,
       coord:{
           x:this.coord.x,
           y:this.coord.y,
           z:this.coord.z
       },
       createdBy: this.$store.getters.user.email
      };
      this.$store.dispatch("createSpot", spotData);
       this.$store.dispatch('loadSpotContent', spotData.id);
     this.$router.push('/spot/'+spotData.id)
     
      this.createSpotdialog= false;
      this.title= "";
      this.coord.x="";
      this.coord.y="";
      this.coord.z="";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/edit/createSpot.vue